const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const ReportStudentBody = require("./ReportStudentBody");
const SortableTable = require("./SortableTable");
const CopyTable = require("./data/CopyTable");
const ClassesUtil = require("./util/ClassesUtil");
const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withSetURL = require("../core/hoc/withSetURL");
const StatsIcon = require("../core/view/StatsIcon");
const Link = require("../core/view/Link");
const ActivityTabContent = require("../core/view/ActivityTabContent");
const InfoIcon = require("../office/InfoIcon");
const URLMake = require("../../shared/URLMake");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/ReportClasses.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportStudents",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			students: PT.object.isRequired,
			filters: PT.object,
			currentYear: PT.number, // beta schools won't have this

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				filters: {},
			};
		},

		filterBy: function(col, val) {
			const {pageData} = this.props;
			const filters = {
				grade: pageData.grade || null,
				chapter: pageData.chapter || null,
				block: pageData.block || null,
				typeID: pageData.typeID || null,
				bookTest: null,
			};

			if (filters[col] !== parseInt(val)) {
				filters[col] = val;
				if (col === "grade") {
					filters.chapter = null;
					filters.block = null;
					filters.typeID = null;
				} else if (col === "chapter") {
					if (ClassesUtil.isFilterForBookTest({chapter: val})) {
						filters.bookTest = val.slice(8);
						filters.chapter = null;
					} else if (filters.grade === "lab") {
						filters.typeID = val;
						filters.chapter = null;
					}
					filters.block = null;
				}
				this.props.setURL(
					URLMake.forSchool(
						"reports",
						"students",
						_.extend({}, pageData, filters)
					)
				);
			}
			this.setState(filters);
		},

		renderTable: function(students) {
			const {filters, currentYear, pageData = {}} = this.props;
			const {classID, schoolID} = pageData;
			const {days} = filters;
			const yearFilter = filters.yearFilter && parseInt(filters.yearFilter);
			let studentsArr = [];
			const filteredStudents = _.filter(students, s => {
				const studentClass = _.get(s, "class.id");
				const studentSchool = _.get(s, "school.id");
				if (
					(s.inactive && yearFilter === currentYear) ||
					(classID && studentClass !== parseInt(classID)) ||
					(schoolID && studentSchool !== parseInt(schoolID))
				) {
					return false;
				}
				return true;
			});
			const columnNames = [
				"name",
				"school",
				"class",
				"level",
				"grade",
				"played",
				"star",
				"trophy",
				"pc",
				"time",
			];
			_.each(filteredStudents, s => {
				const totalStats = s[days];
				const timeSpent = totalStats.totalTimeData
					? ClassesUtil.convertStudentStats(totalStats).timeSpent
					: totalStats.timeSpent;
				const minutes = (timeSpent || 0) / 60;
				const studentName = ClassesUtil.getStudentName(s.user);
				const rowData = {
					name: (
						<Link
							to={URLMake.forSchool("reports", "students", {
								studentID: s.userID,
							})}
							className={styles.link}
						>
							{studentName}
						</Link>
					),
					nameValue: studentName,
					school: s.school ? (
						<Link
							to={`/dashboard/reports/schools/${s.school.id}/classes`}
							className={styles.link}
						>
							{s.school.displayName}
						</Link>
					) : (
						""
					),
					schoolValue: _.get(s, "school.displayName", ""),
					class: (
						<div className={styles.name}>
							{_.get(s, "class.displayName", "")}
						</div>
					),
					classValue: _.get(s, "class.displayName", ""),
					level: s.gradeID,
					grade: getDisplayedGradeLabel(_.get(s, "class.displayedGrade")),
					gradeSort: _.get(s, "class.displayedGrade"),
					played: ClassesUtil.getUserDate(s.all.lastPlayed, s.all.lastPlayedTZ),
					star: totalStats.stars || 0,
					trophy: totalStats.trophies || 0,
					pc: totalStats.problemsCorrect || 0,
					time: ClassesUtil.timeToShortString(minutes),
					inactive: s.inactive,
				};
				studentsArr.push(rowData);
			});
			studentsArr = _.sortBy(studentsArr, c => _.toLower(c.className));

			const headers = {
				name: "Name",
				school: "School",
				class: "Class",
				level: "BA Level",
				grade: "Grade",
				played: "Last Played",
				star: (
					<StatsIcon type="star" style="office" className={styles.iconHeader} />
				),
				trophy: (
					<StatsIcon
						type="trophy"
						style="office"
						className={styles.iconHeader}
					/>
				),
				pc: (
					<StatsIcon
						type="check"
						style="office"
						className={styles.iconHeader}
					/>
				),
				time: (
					<StatsIcon type="time" style="office" className={styles.iconHeader} />
				),
			};

			const copy = CopyTable.getReportHeaderCopy("list");
			const categories = (
				<div
					className={styles.categoriesStudents + " header-reportStudentList"}
				>
					<div className={styles.tbLeft + " " + styles.totals4}>
						<div className={styles.infoHeader}>
							<InfoIcon
								title={copy.total.title}
								text={copy.total.text}
								className={styles.infoIcon}
								isModal={true}
								modalClass={styles.infoModal}
								modalTextClass={styles.infoModalText}
							/>
							{copy.total.title}
						</div>
					</div>
				</div>
			);

			const sortFunctions = {
				name: body =>
					_.sortBy(body, ["inactive", r => _.toLower(_.trim(r.nameValue))]),
				school: body =>
					_.sortBy(body, ["inactive", r => _.toLower(r.schoolValue)]),
				class: body =>
					_.sortBy(body, ["inactive", r => _.toLower(r.classValue)]),
				grade: body =>
					_.sortBy(body, [
						"inactive",
						r => (r.gradeSort != null ? r.gradeSort : -1),
					]),
				time: body => {
					return _.sortBy(body, [
						"inactive",
						r => ClassesUtil.timeStringToSeconds(r["time"]),
					]);
				},
				played: body => {
					return _.sortBy(body, [
						"inactive",
						r => ClassesUtil.getSortableDate(r["played"]),
					]);
				},
			};
			const headerClasses = {
				star: styles.statHeader + " " + styles.tbLeft,
				trophy: styles.statHeader,
				pc: styles.statHeader,
				time: styles.statHeader,
			};
			const bodyClasses = {
				played: styles.statPlayed,
				star: styles.statStar + " " + styles.tbLeft,
				trophy: styles.statTrophy,
				pc: styles.statPC,
				time: styles.statTime,
			};

			const widthClasses = {
				name: styles.nameWidth,
				school: styles.nameWidth,
				class: styles.nameWidth,
				level: styles.gradeWidth,
				grade: styles.gradeWidth,
				played: styles.playedWidth,
				star: styles.starWidth,
				trophy: styles.trophyWidth,
				pc: styles.pcWidth,
				time: styles.timeWidth,
			};

			return (
				<div className={styles.body}>
					<SortableTable
						tableID="reportStudentList"
						columnNames={columnNames}
						headers={headers}
						sortableColumns={columnNames}
						initiallySortedBy="name"
						data={studentsArr}
						sortFunctions={sortFunctions}
						bodyClasses={bodyClasses}
						headerClasses={headerClasses}
						widthClasses={widthClasses}
						extraHeader={categories}
						canScroll={true}
						grayOutInactive={true}
					/>
				</div>
			);
		},

		render: function() {
			const students = this.props.students;
			const pageData = this.props.pageData || {};
			const {
				studentID,
				grade,
				chapter,
				block,
				bookTest,
				type,
				date,
				typeID,
			} = pageData;
			let body = null;
			if (studentID) {
				if (type === "progress") {
					body = (
						<ReportStudentBody
							user={this.props.user}
							studentID={studentID}
							gradeNumber={grade}
							chapterNumber={chapter}
							blockNumber={block}
							bookTest={bookTest}
							typeID={typeID}
							pageData={pageData}
							updateStudentFilter={this.filterBy}
							studentsData={students}
						/>
					);
				} else if (type === "activity") {
					const activity = {
						day: date,
						toggleType: "minutes",
					};
					body = (
						<div className={styles.body}>
							<ActivityTabContent
								activity={activity}
								profileID={studentID}
								style={"office"}
								className={styles.activityCalendarContainer}
								calendarClass={styles.calendar}
								dayDetailsClass={styles.dayDetails}
								noSound={true}
								viewType={"teacher"}
							/>
						</div>
					);
				}
			} else {
				body = this.renderTable(students);
			}
			return <div className={styles.inner}>{body}</div>;
		},
	})
);
